import { LockOutlined, MailOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Form,
  Input,
  notification,
  Row,
  Typography
} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../../assets/scss/components/login.scss';
import {
  GIFT_API_TOKEN,
  GIFT_AUTH_CODE_URL
} from '../../configs/urls';
import authService from '../../services/auth';
const { Title } = Typography;

const credentials = [
  {
    login: 'admin@gmail.com',
    password: 'admin123',
  },
  {
    login: 'manager@gmail.com',
    password: 'manager',
  },
  {
    login: 'support@githubit.com',
    password: 'seller',
  },
  {
    login: 'moderator@gmail.com',
    password: 'moderator',
  },
  {
    login: 'deliveryman@gmail.com',
    password: 'deliveryman',
  },
];

const Login = () => {
  const navigator = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [authcode, setAuthcode] = useState('');
  const [giftauthtoken, setGiftAuthToken] = useState('');
  const { settings } = useSelector((state) => state.globalSettings);

  const handleLogin = (values) => {
    const body = {
      email: values.email,
      password: values.password,
    };
    setLoading(true);
    try {
       authService
      .login(body)
      .then((res) => {
          console.log('res => ', res);
             const uuid = res.data.uuid;
             const number = res.data.phone;
               console.log('uuid => ', uuid);
               navigator('/otp', { state: { uuid, email:  body.email, password: body.password, number } });
      })
      .finally(() => setLoading(false));
    } catch (error) {
       console.log('error => ', error);
       
       notification.error({
         message: 'Something went wrong',
         description: error.response.data.message
       })
    }
  };

  const handleGiftApiLogin = async () => {
    if (localStorage.getItem(GIFT_API_TOKEN) === null) {
      await axios.get(GIFT_AUTH_CODE_URL).then((rsponse) => {
        setAuthcode(rsponse.data['authorizationCode']);
        handleGiftApiToken(rsponse.data['authorizationCode']);
      });
    }
  };

  const handleGiftApiToken = async (code) => {
    if (localStorage.getItem(GIFT_API_TOKEN) === null) {
      try {
        const response = await axios.get(
          `/api/v1/dashboard/quickgift/authtoken`,
          {
            params: { authcode: code },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              Accept: 'application/json',
            },
          }
        );

        if (response.data?.token) {
          localStorage.setItem(GIFT_API_TOKEN, response.data.token);
        }
      } catch (error) {
        console.error('Error fetching auth token:', error);
        // Handle error appropriately
      }
    }
  };

  const copyCredentials = (event, item) => {
    event.preventDefault();
    form.setFieldsValue({ email: item.login, password: item.password });
  };

  useEffect(() => {
    if (localStorage.getItem(GIFT_API_TOKEN) !== null) {
      setGiftAuthToken(localStorage.getItem(GIFT_API_TOKEN));
    }
  }, []);

  return (
    <div className='login-container'>
      <div className='container d-flex flex-column justify-content-center h-100'>
        <Row justify='center' className='w-100'>
          <Col xs={20} sm={20} md={20} lg={10}>
            <Card>
              <div className='my-4'>
                <div className='app-brand text-center'>
                  <Title style={{ fontSize: 36 }}>
                    {settings.title || 'Givzo'}
                  </Title>
                </div>
                <Row justify='center'>
                  <Col xs={24} sm={24} md={20} lg={20}>
                    <Form
                      name='login-form'
                      layout='vertical'
                      form={form}
                      onFinish={handleLogin}
                    >
                      <Form.Item
                        name='email'
                        label='Email'
                        rules={[
                          {
                            required: true,
                            message: 'Please input your Email!',
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <MailOutlined className='site-form-item-icon' />
                          }
                          placeholder='Email'
                        />
                      </Form.Item>

                      <Form.Item
                        name='password'
                        label='Password'
                        rules={[
                          {
                            required: true,
                            message: 'Please input your password!',
                          },
                        ]}
                      >
                        <Input.Password
                          prefix={
                            <LockOutlined className='site-form-item-icon' />
                          }
                          placeholder='Password'
                        />
                      </Form.Item>

                      <Form.Item className='login-input'>
                        <Button
                          type='primary'
                          htmlType='submit'
                          className='login-form-button'
                          loading={loading}
                          onClick={handleGiftApiLogin}
                        >
                          Login
                        </Button>
                      </Form.Item>
                      {process.env.REACT_APP_IS_DEMO === 'true' ? (
                        <Descriptions bordered size='small'>
                          {credentials.map((item, idx) => (
                            <React.Fragment key={idx}>
                              <Descriptions.Item span={2} label={item.login}>
                                {item.password}
                              </Descriptions.Item>
                              <Descriptions.Item span={1}>
                                <a
                                  href='/'
                                  className='copy-link'
                                  onClick={(event) =>
                                    copyCredentials(event, item)
                                  }
                                >
                                  Copy
                                </a>
                              </Descriptions.Item>
                            </React.Fragment>
                          ))}
                        </Descriptions>
                      ) : (
                        ''
                      )}
                    </Form>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default Login;

export const isAdminOrManager = (role) => {
  return role === 'admin' || role === 'manager';
};
